import { render, staticRenderFns } from "./smallCheckBox.vue?vue&type=template&id=03bc3f12&"
import script from "./smallCheckBox.vue?vue&type=script&lang=js&"
export * from "./smallCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports